import {
  Alert,
  Button,
  Checkbox,
  Collapse,
  Space,
  Tag,
  Tooltip,
  Typography,
} from "antd";
import { formatUsd } from "./status";

const { Text, Paragraph } = Typography;

function resumoParams(params) {
  return Object.entries(params || {})
    .filter(([, valor]) => valor !== null && valor !== undefined)
    .map(
      ([nome, valor]) =>
        `${nome}: ${Array.isArray(valor) ? valor.join(", ") : String(valor)}`
    )
    .join(" · ");
}

function Lista({ itens }) {
  return (
    <ul style={{ margin: 0, paddingLeft: 18 }}>
      {itens.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
}

export default function PlanoPanel({
  plano,
  desatualizado,
  agendarMesmoAssim,
  onAgendarMesmoAssim,
  amostra,
  amostraLoading,
  onAmostra,
}) {
  if (!plano) return null;
  const naoAtendido = plano.nao_atendido || [];
  const avisos = plano.avisos || [];
  const achados = [...(plano.achados || []), ...(amostra?.achados || [])];
  return (
    <div
      style={{
        border: "1px solid var(--ouran-border, #d9d9d9)",
        borderRadius: 8,
        padding: 16,
        display: "flex",
        flexDirection: "column",
        gap: 12,
      }}>
      {desatualizado && (
        <Alert
          type="warning"
          showIcon
          message="O pedido ou a configuração mudou depois do último plano. Planeje de novo antes de salvar."
        />
      )}
      {plano.editado_a_mao && (
        <Alert
          type="info"
          showIcon
          message="Prompt editado à mão: a versão em uso não veio do planejador."
        />
      )}
      <div>
        <Text strong>Entendimento</Text>
        <Paragraph style={{ margin: "4px 0 0" }}>
          {plano.entendimento || "-"}
        </Paragraph>
      </div>
      <div>
        <Text strong>Fontes usadas</Text>
        <div style={{ marginTop: 4 }}>
          <Space size={[4, 4]} wrap>
            {(plano.fontes || []).map((fonte) => (
              <Tooltip key={fonte.alias} title={resumoParams(fonte.params)}>
                <Tag color="blue">
                  {fonte.alias} · {fonte.nome || fonte.source}
                </Tag>
              </Tooltip>
            ))}
          </Space>
        </div>
      </div>
      {avisos.length > 0 && (
        <Alert
          type="warning"
          showIcon
          message="Avisos"
          description={<Lista itens={avisos} />}
        />
      )}
      {naoAtendido.length > 0 && (
        <Alert
          type="error"
          showIcon
          message="Sem dado para estes trechos do pedido"
          description={
            <div>
              <Lista itens={naoAtendido} />
              {onAgendarMesmoAssim && (
                <Checkbox
                  style={{ marginTop: 8 }}
                  checked={agendarMesmoAssim}
                  onChange={(e) => onAgendarMesmoAssim(e.target.checked)}>
                  Agendar mesmo assim (o relatório dirá que o dado não existe)
                </Checkbox>
              )}
            </div>
          }
        />
      )}
      {achados.length > 0 && (
        <Alert
          type="error"
          showIcon
          message="Nomes fora do escopo da loja"
          description={
            <Lista
              itens={achados.map((achado) => `${achado.tipo}: ${achado.valor}`)}
            />
          }
        />
      )}
      {plano.tamanho_chars !== undefined && (
        <Text type="secondary">
          Contexto de {plano.tamanho_chars.toLocaleString("pt-BR")} caracteres
          na pré-visualização ({plano.previa?.start} a {plano.previa?.end}, fim
          exclusivo). Planejamento: {formatUsd(plano.custo_planejamento)}.
        </Text>
      )}
      {plano.rendered_user && (
        <Collapse
          size="small"
          items={[
            {
              key: "prompt",
              label: "Ver o prompt montado",
              children: (
                <pre
                  style={{
                    whiteSpace: "pre-wrap",
                    maxHeight: 320,
                    overflow: "auto",
                    margin: 0,
                    fontSize: 12,
                  }}>
                  {plano.rendered_user}
                </pre>
              ),
            },
          ]}
        />
      )}
      {onAmostra && (
        <div>
          <Button onClick={onAmostra} loading={amostraLoading}>
            Gerar amostra
          </Button>
          <Text type="secondary" style={{ marginLeft: 8 }}>
            Chama o modelo de verdade, com custo, sem criar execução.
          </Text>
        </div>
      )}
      {amostra?.sem_dados && (
        <Alert type="info" showIcon message={amostra.aviso} />
      )}
      {amostra && !amostra.sem_dados && (
        <div>
          <Text strong>Amostra</Text>
          <Text type="secondary" style={{ marginLeft: 8 }}>
            {formatUsd(amostra.custo_usd)} · {amostra.input_tokens} /{" "}
            {amostra.output_tokens} tokens
          </Text>
          <pre
            style={{
              whiteSpace: "pre-wrap",
              marginTop: 4,
              padding: 12,
              background: "var(--ouran-card-header-bg, #fafafa)",
              borderRadius: 6,
              fontFamily: "inherit",
            }}>
            {amostra.texto}
          </pre>
        </div>
      )}
    </div>
  );
}
